import React, { useState, useEffect } from 'react';
import './App.css';
import CreatorStudio from './CreatorStudio';
import { 
  Authenticator, 
  Button, 
  Heading, 
  View, 
  useTheme,
  useAuthenticator
} from '@aws-amplify/ui-react';
import { fetchUserAttributes } from '@aws-amplify/auth'; // Correct V6 import
import '@aws-amplify/ui-react/styles.css';

const AppContent = ({setShowAuthenticator}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { authStatus } = useAuthenticator(context => [context.authStatus]);

  const handleNotifyClick = () => {
    if (authStatus === 'authenticated') {
      setIsModalOpen(true);
    } else {
      setShowAuthenticator(true);
    }
  }

  // This handles closing the modal by clicking the backdrop
  useEffect(() => {
    const handleCheckboxChange = () => {
      setIsModalOpen(document.getElementById('modal-toggle').checked);
    };
    const checkbox = document.getElementById('modal-toggle');
    checkbox.addEventListener('change', handleCheckboxChange);
    return () => checkbox.removeEventListener('change', handleCheckboxChange);
  }, []);

  // Update checkbox state if modal is closed from within the component
  useEffect(() => {
    document.getElementById('modal-toggle').checked = isModalOpen;
  }, [isModalOpen]);


  return (
    <div>
      <div className="background-animation"></div>

      <input 
        type="checkbox" 
        id="modal-toggle" 
        className="modal-toggle-input" 
        readOnly
      />

      <div className="container">
        <div className="content-box">
          
          <h1 className="logo"><span className="logo-q">Q</span>ED</h1>
          
          <h2>India's IP Engine</h2>
          <p className="subtitle">
            For the next generation of manga, webtoon, & novel creators.
          </p>

          <div className="goals-container">
            <div className="goal-tag"><strong>UPLOAD</strong> your story</div>
            <div className="goal-tag"><strong>SHARE</strong> with the community</div>
            <div className="goal-tag"><strong>BUILD</strong> your universe</div>
          </div>

          <p className="cta-text">
            Platform Launch Imminent
          </p>
          
          <div onClick={handleNotifyClick} className="cta-button">
            Notify Me
          </div>

          <CreatorStudio setIsModalOpen={setIsModalOpen} />

        </div>
      </div>

      <div className="modal-container">
        <div className="modal-box">
          <label htmlFor="modal-toggle" className="modal-close-btn" onClick={() => setIsModalOpen(false)}>&times;</label>
          <h3>Feature Under Development</h3>
          <p>Our backend services are being built right now.</p>
          <p>This "Notify Me" feature will be live soon, along with our full creator portal. Thank you for your patience!</p>
        </div>
      </div>
    </div>
  );
};

const AuthOverlay = ({ formFields, components, loginMechanisms }) => (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 200,
  }}>
    <Authenticator formFields={formFields} components={components} loginMechanisms={loginMechanisms} />
  </div>
);


const App = () => {
  const [showAuthenticator, setShowAuthenticator] = useState(false);
  const [fetchedDisplayName, setFetchedDisplayName] = useState('');
  const { tokens } = useTheme();
  const { user, signOut, authStatus } = useAuthenticator(context => [context.user, context.signOut, context.authStatus]);

  useEffect(() => {
    if (authStatus === 'authenticated') {
      setShowAuthenticator(false);
      // Explicitly fetch user attributes using the correct V6 function
      fetchUserAttributes().then(attributes => {
          const userName = attributes.name || user.username; // attributes is a flat object like { name: '...', email: '...' }
          setFetchedDisplayName(userName);
        })
        .catch(err => {
          console.error("Error fetching user attributes:", err);
          setFetchedDisplayName(user.username); // Fallback to username from useAuthenticator
        });
    } else {
      setFetchedDisplayName(''); // Clear name on logout
    }
  }, [authStatus, user]); // Depend on user as well, in case it updates

  const components = {
    Header() {
      return (
        <View textAlign="center" padding={tokens.space.large}>
          <h1 className="logo" style={{fontSize: "4rem", margin: "0 auto"}}><span className="logo-q">Q</span>ED</h1>
        </View>
      );
    },
  };

  const formFields = {
    signUp: {
      email: { order: 1, label: 'Email', placeholder: 'Enter your Email', isRequired: true },
      name: { order: 2, label: 'Name', placeholder: 'Enter your Name', isRequired: true },
    },
  };

  return (
    <View>
      <div style={{ position: 'absolute', top: '1rem', right: '1rem', zIndex: '100' }}>
        {authStatus === 'authenticated' && user ? (
          <>
            <Heading level={6} color="white">Welcome, {fetchedDisplayName || user.username}</Heading>
            <Button onClick={signOut} variation="primary" size="small">Sign Out</Button>
          </>
        ) : (
          <Button onClick={() => setShowAuthenticator(true)} variation="primary">Sign In / Sign Up</Button>
        )}
      </div>

      {showAuthenticator && <AuthOverlay components={components} formFields={formFields} loginMechanisms={['email']} />}
      
      <AppContent setShowAuthenticator={setShowAuthenticator} />
    </View>
  );
}


// Wrap the App in the Authenticator.Provider
const AppWrapper = () => (
  <Authenticator.Provider>
    <App />
  </Authenticator.Provider>
);

export default AppWrapper;